module.exports = __webpack_public_path__ + "img/step.57d2a5df.png";